var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitment3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172075",
    "data-name": "\\uADF8\\uB8F9 172075",
    transform: "translate(-146 -685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153059",
    "data-name": "\\uC0AC\\uAC01\\uD615 153059",
    transform: "translate(146 743) rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153060",
    "data-name": "\\uC0AC\\uAC01\\uD615 153060",
    transform: "translate(175 714) rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment3);
export default __webpack_public_path__ + "static/media/recruitment3.9f4c8d1bf06b919778f21cef57ef4f79.svg";
export { ForwardRef as ReactComponent };